import { useSelector } from 'react-redux';
import {
  selectShowtimeDomain,
  useGetOrganizationQuery,
} from '@carboncopyco/data';
import { useParams } from 'react-router-dom';

export const useShowtimeUrl = () => {
  const showtimeDomain = useSelector(selectShowtimeDomain);
  const { organizationId } = useParams();
  const { data: organization } = useGetOrganizationQuery({
    id: organizationId,
  });
  const slug = organization.slugName;
  const showtimeDemoUrl = (encodedToken: string) =>
    `https://${showtimeDomain}/demo/${encodedToken}`;
  const showtimePlayUrl = (encodedToken: string) =>
    `https://${showtimeDomain}/play/${encodedToken}`;

  const showtimeTourUrl = (encodedToken: string) =>
    `https://${showtimeDomain}/tour/${encodedToken}`;

  const showtimeShareUrl = (encodedToken: string) =>
    `https://${showtimeDomain}/${slug}/${encodedToken}`;

  const showtimeWelcomeMatPreviewUrl = ({
    securityLevel,
    assetType,
    requireName,
    requireEmail,
    presenterName,
    emailDomain,
    welcomeMatTitle,
  }) =>
    `https://${showtimeDomain}/form/preview?securityLevel=${
      securityLevel
    }&assetType=${assetType}&requireName=${requireName}&requireEmail=${
      requireEmail
    }&creatorName=${presenterName}&organizationName=${
      organization.organizationName
    }&organizationLogo=${encodeURIComponent(organization.logo)}&emailDomain=${
      emailDomain
    }&welcomeMatTitle=${welcomeMatTitle}`;

  const openShowtimeDemo = (encodedToken: string) =>
    window.open(
      showtimeDemoUrl(encodedToken),
      '_blank',
      'noopener, noreferrer'
    );

  const openShowtimeTour = (encodedToken: string) =>
    window.open(
      showtimeTourUrl(encodedToken),
      '_blank',
      'noopener, noreferrer'
    );

  return {
    showtimeDemoUrl,
    showtimePlayUrl,
    showtimeShareUrl,
    showtimeTourUrl,
    showtimeWelcomeMatPreviewUrl,
    openShowtimeDemo,
    openShowtimeTour,
  };
};
